// src/components/Layout.jsx
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HiOutlineMenu } from "react-icons/hi";

const navItems = [
  { name: "Dashboard", path: "/dashboard" },
  { name: "Users", path: "/users" },
  { name: "Requests", path: "/requests" },
  { name: "Payments", path: "/payments" },
  { name: "Diagnostics", path: "/diagnostics" },
];

export default function Layout({ children }) {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const logout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  return (
    <div className="flex w-screen h-screen bg-gray-100 overflow-hidden">
      {/* Sidebar */}
      <aside className="w-64 bg-indigo-600 text-indigo-100 flex flex-col flex-shrink-0">
  <div className="text-2xl font-bold p-6 text-center border-b border-indigo-500 text-white">
    Core60
  </div>

  <nav className="flex-1 overflow-y-auto">
    {navItems.map((item) => (
      <Link
        key={item.path}
        to={item.path}
        className={`block px-6 py-3 transition duration-200 ${
          location.pathname === item.path
            ? "bg-indigo-800 text-white font-semibold"
            : "hover:bg-indigo-500 text-indigo-100"
        }`}
      >
        {item.name}
      </Link>
    ))}
  </nav>

  <button
    onClick={() => {
      localStorage.removeItem("token");
      window.location.href = "/";
    }}
    className="m-4 mt-auto bg-red-600 text-white py-2 rounded hover:bg-red-700"
  >
    Logout
  </button>
</aside>


      {/* Mobile header */}
      <div className="md:hidden fixed top-0 left-0 right-0 bg-white z-20 shadow">
        <div className="flex items-center justify-between p-3">
          <div className="text-lg font-semibold">Core60 Admin</div>
          <div className="flex items-center gap-2">
            <button onClick={() => setOpen(!open)} className="p-2 rounded bg-gray-100">
              <HiOutlineMenu />
            </button>
            <button onClick={logout} className="px-3 py-1 rounded bg-red-600 text-white">Logout</button>
          </div>
        </div>
        {open && (
          <div className="p-3 border-t">
            {navItems.map(item => (
              <Link key={item.path} to={item.path} className="block py-2">{item.name}</Link>
            ))}
          </div>
        )}
      </div>

      {/* Main Content */}
      <div className="flex flex-col flex-1 min-w-0 md:pl-0">
        <header className="bg-white shadow px-6 py-4 hidden md:flex items-center justify-between">
          <h1 className="text-xl font-bold text-gray-700">Admin Panel</h1>
          <div className="text-sm text-gray-600">Signed in as <strong className="ml-1">{JSON.parse(localStorage.getItem("user") || "{}").user_id || "—"}</strong></div>
        </header>

        <main className="flex-1 p-6 overflow-y-auto pt-16 md:pt-6">
          {children}
        </main>
      </div>
    </div>
  );
}
